export default __webpack_public_path__ + "static/DrSunilAnand-1010eff4b906770067ff97dc172f21b8.png";